<script lang="ts">
	import type { Snippet } from 'svelte';
	import type { ClassValue } from 'svelte/elements';

	interface Props {
		margin?: boolean;
		gridClass?: string | undefined;
		gridWidth?: number | undefined;
		class?: ClassValue | undefined;
		children?: Snippet;
	}

	let {
		margin = false,
		gridClass,
		gridWidth = $bindable(),
		children,
		class: className
	}: Props = $props();
</script>

<div
	bind:clientWidth={gridWidth}
	class={['grid-wrapper', className]}
	style="--grid-margin: {margin ? '20px' : 'auto'}"
>
	<div
		class={[
			'grid grid-cols-4 gap-x-3 lg:grid-cols-16 lg:gap-x-4',
			...(Array.isArray(gridClass) ? gridClass : [gridClass])
		]}
	>
		{@render children?.()}
	</div>
</div>

<style lang="scss">
	.grid-wrapper {
		margin-left: auto;
		margin-right: auto;
		max-width: 1400px;

		@media (max-width: 1440px) {
			margin-left: var(--grid-margin);
			margin-right: var(--grid-margin);
		}
	}
</style>
